// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"145341b6","610":"af848071","922":"2e566225","939":"a3e47474"}[chunkId] + ".chunk.js";
};